export const NHTSA_BASE_URL = 'https://vpic.nhtsa.dot.gov/api/vehicles'
export const NHTSA_RESPONSE_FORMAT = 'json'
